import React from 'react'
import GoogleMapAppUsersWithProvider from '../../../global/components/map/GoogleMapAppUsers'
import Scorecard from './Scorecard'

const GolfCourse = (props) => {
  return <React.Fragment>
    <Scorecard {...props} />
  </React.Fragment>
}

export const GolfCourseMap = (props) => {
  return <React.Fragment>
    <GoogleMapAppUsersWithProvider />
  </React.Fragment>
}


export default GolfCourse